import { Injectable } from '@angular/core';
import { BaseApi } from '../base-api.service';
import { ApplicantService } from '../applicant.service';
import { map } from 'rxjs/operators';

@Injectable()
export class FruitsServiceService {
  private applicantId: string;
  private getBaseUrl = "";
  constructor(    private api: BaseApi,     private applicant: ApplicantService,) { 
    this.applicantId = applicant.getApplicantID();
    this.getBaseUrl = `/applicants/${this.applicantId}/assets/bhoomi`;
  }

  getLandRecordDataUsingFruitsAPI(data) {
    return this.api.postResMpWebhook('webhook/getFruitDetails', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getCropsList(data){
    return this.api.postResMp('/users/getCropList', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getBREStatusKA(data){
    return this.api.postResMp('/land-records/getBreStatusKA', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getApplicantData(data){
    return this.api.postResMp('/users/getApplicantData', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getBreStatus(){
    return this.api.newGet(`/users/getBreStatus?applicantId=${this.applicantId}`);
  }

  get() {
    return this.api.newGet(this.getBaseUrl);
  }

  deleteBhoomiRecord(i){
    return this.api.postResp('/loansrecord/dellanddetails',{appId : this.applicantId,type:"bhoomi",index:i}).pipe(map(resp => {
      console.log("resp in deleteBhoomiRecord " + JSON.stringify(resp));
      return resp;
    }))
  }

  save_bhoomi_details(index, data) {
    return this.api.postResp('/loansrecord/updatelanddetails', {appId : this.applicantId,index:index,bhoomi_details:data, input:data}).pipe(map(resp => {
      console.log("resp in service payrtc " + JSON.stringify(resp));
      return resp;
    })) 
  }
}
